/**
 * Copyright Mántum All Rights Reserved.
 */
type PropTypes = {
    children?: React.ReactNode;
    disabled?: boolean;
    name?: string;
    optional?: boolean;
};

export default function Label(props: PropTypes) {
    // prettier-ignore
    const { 
        optional = true,
        disabled = false
    } = props;

    return (
        <label className='text-sm text-gray-600'>
            <div className='mb-1 flex gap-1 truncate'>
                {props.name}
                {props.name && !optional && !disabled && (
                    <div className='text-error'>*</div>
                )}
            </div>
            {props.children}
        </label>
    );
}
